var base = require('settings/subscription/subscribe-braintree');

Vue.component('spark-subscribe-braintree', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/subscription/subscribe-braintree.js